import { render, staticRenderFns } from "./transfer_create.vue?vue&type=template&id=794ecf50"
import script from "./transfer_create.vue?vue&type=script&lang=js"
export * from "./transfer_create.vue?vue&type=script&lang=js"
import style0 from "./transfer_create.vue?vue&type=style&index=0&id=794ecf50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports